import { fetchWithStatus } from '../../../assets/js/utils/fetchWithStatus';

async function fetchUsageAmountForOrganizations(
    getUsageAmountForOrganizationsApiUrl,
    usageUnitId,
    organizationIds,
    statusUpdateCallback,
) {
    const response = await fetch(getUsageAmountForOrganizationsApiUrl, {
        method: 'POST',
        body: JSON.stringify({
            usageUnitId: usageUnitId,
            organizationIds: organizationIds,
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        const message = `An error has occurred: ${response.status}`;
        throw new Error(message);
    }

    const location = response.headers.get('location');
    const retryAfterNumber = Number(response.headers.get('retry-after'));
    return await fetchWithStatus(location, retryAfterNumber, statusUpdateCallback);
}

export { fetchUsageAmountForOrganizations };
